var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'nav-lists-container',
    {
      'nav-lists-container--3-col': _vm.hasTabs && _vm.hasCard,
      'nav-lists-container--4-col': (!_vm.hasTabs && _vm.hasCard) || (!_vm.hasCard && _vm.hasTabs),
      'nav-lists-container--just-lists': !_vm.hasTabs && !_vm.hasCard,
    } ]},_vm._l((_vm.lists),function(list){return _c('nav-list',{key:list.columnHeader,attrs:{"column-header":list.columnHeader,"uid":list.uid,"links":_vm.filterLinks(list.links)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }